<template>
  <div class="data-list">
    <content-panel>
      <!-- <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
          >
            <el-form-item label="模版ID" prop="ruleValue">
              <el-input
                v-model="searchForm.ruleValue"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
           <el-form-item label="模版主题" prop="ruleValue">
              <el-input
                v-model="searchForm.ruleValue"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="更新人" prop="createdName">
              <el-input
                v-model="searchForm.createdName"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
           
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">
              查询
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template> -->
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd">
            获取token
          </el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column  prop="name" label="名称" align="center"></el-table-column>
          <el-table-column  prop="content" label="获取内容" align="center"></el-table-column>
          <el-table-column  prop="createdTime" label="获取时间" align="center"></el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <add-dialog
      :isNewAddPopup.sync="isNewAddPopup"
      :formItems="tokenFormItems"
      :editData.sync='editData' 
      v-if="isNewAddPopup"
      @onConfirm="onConfirm"
    />
    <q-dialog 
      :visible="isResult "
      title="结果"
      width="600px"
      :innerScroll="false"
      :offsetHeight="170"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onCancel"
    >
      <div class="box">
        <span class="key">H5：</span>
        <div class="value">{{tokenResult.h5Token}}</div>
      </div>
      <div class="box">
        <span class="key">小程序：</span>
        <div class="value">{{tokenResult.xcxToken}}</div>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import { tokenFormItems } from '../config'
import AddDialog from '../add-dialog.vue';
export default {
  name: "weChatKeyList",
  mixins: [tableMixin],
  components: {
    AddDialog
  },
  data() {
    return {
      isNewAddPopup: false,
      searchForm: {
        ruleValue: '',
        ruleType: "",
        createdName: "",
        updatedTime: [],
      },
     
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {
      },
      loading: false,
      tokenFormItems,
      editData: {
        uid: '',
      },
      isResult: false,
      tokenResult: {}
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure
        .queryRecordList(params)
          .then(({ data: { list, total } }) => {
            this.tableData = list || [];
            this.total = total;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd() {
      this.editData.uid = ''
      this.isNewAddPopup = true
    },
    onConfirm() {
      this.$api.configure.getToken(this.editData.uid)
        .then(res => {
          this.tokenResult = res.data
          this.isNewAddPopup = false
          this.init()
          this.isResult = true
        })
    },
    onCancel() {
      this.isResult = false
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input
  width 220px !important
.box {
  margin-top: 20px;
  display: flex;
  .key {
    display: inline-block;
    width: 60px;
  }
  .value {
     width: 500px;
  }
}
</style>
